import { TFunction } from 'i18next'

import { Permission } from '../../../../entities/permissions/types/permission.types'
import { PermissionSection } from '../types/roles-page-types'

export const getRolePermissions = (permissions: Permission[], t: TFunction): PermissionSection[] => {
  return permissions.reduce((acc: PermissionSection[], value: Permission) => {
    const sectionId = value.codename.split('_')[0]
    let section = acc.find((section) => section.sectionId === sectionId)
    if (!section) {
      section = {
        sectionId: sectionId,
        sectionName: t(`rolesPage.addRoleModal.sections.${sectionId}`),
        permissions: [
          {
            id: value.id,
            name: t(`rolesPage.addRoleModal.permissions.${value.codename}`),
            key: value.codename,
          },
        ],
      }

      acc.push(section)
    } else {
      section.permissions.push({
        id: value.id,
        name: t(`rolesPage.addRoleModal.permissions.${value.codename}`),
        key: value.codename,
      })
    }

    return acc
  }, [])
}
